import { render, staticRenderFns } from "./Timeline.vue?vue&type=template&id=2c06fdb9"
import script from "./Timeline.vue?vue&type=script&lang=js"
export * from "./Timeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports